// _ means that its a sub section
// for example userManagement_roles means that  roles is a subsection of userManagement
// menu bar and main section permissions constants
export const permissions = {
    userManagement: 'USER_MANAGEMENT.VIEW',
    userManagement_userManagement: 'USER_MANAGEMENT.USER.VIEW',
    admin: 'ADMIN.VIEW',
    admin_general: 'ADMIN.ADMIN_GENERAL.VIEW',
    admin_care: 'ADMIN.CARE.VIEW',
    admin_personalFinance: 'ADMIN.PERSONAL_FINANCE.VIEW',
    admin_billing: 'ADMIN.ADMIN_BILLING.VIEW',
    admin_dataDrivenOutcome: 'ADMIN.DATA_DRIVEN_OUTCOME.VIEW',
    admin_serviceDirectory: 'ADMIN.SERVICE_DIRECTORY.VIEW',
    agency: 'AGENCY.VIEW',
    agency_agencyWideDocument: 'AGENCY.AGENCY_WIDE_DOCUMENT.VIEW',
    billing: 'BILLING.VIEW',
    billing_attendance: 'BILLING.ATTENDANCE.VIEW',
    billing_professionalClaim: 'BILLING.PROFESSIONAL_CLAIM.VIEW',
    //USER__MANAGEMENT
    userManagement_roles: 'USER_MANAGEMENT.ROLES.VIEW',
    userManagement_roles_create: 'USER_MANAGEMENT.ROLES.CREATE',
    userManagement_roles_update: 'USER_MANAGEMENT.ROLES.UPDATE',
    userManagement_roles_delete: 'USER_MANAGEMENT.ROLES.DELETE',
    /// USER__MANAGEMENT_____USER
    user_management_user_view: 'USER_MANAGEMENT.USER.VIEW',
    user_management_user_create: 'USER_MANAGEMENT.USER.CREATE',
    user_management_user_update: 'USER_MANAGEMENT.USER.UPDATE',
    user_management_user_delete: 'USER_MANAGEMENT.USER.DELETE',
    //   USER_MANAGEMENT_____NOTIFICATION____MANAGER
    user_management_notification_manager_view: 'USER_MANAGEMENT.NOTIFICATION_MANAGER.VIEW',
    user_management_notification_manager_update: 'USER_MANAGEMENT.NOTIFICATION_MANAGER.UPDATE',
    // USER_MANAGEMENT_____IMPORT__DATA
    user_management_import_client_view: 'USER_MANAGEMENT.IMPORT_CLIENT.VIEW',
// USER_MANAGEMENT_____IMPORT__CAREGIVER
    user_management_import_caregiver_view: 'USER_MANAGEMENT.IMPORT_CAREGIVER.VIEW',
    //    ADMIN______BILLING
    // FUNDING__SOURCE
    admin_billing_fundingSource_view: 'ADMIN.ADMIN_BILLING.FUNDING_SOURCE.VIEW',
    admin_billing_fundingSource_create: 'ADMIN.ADMIN_BILLING.FUNDING_SOURCE.CREATE',
    admin_billing_fundingSource_update: 'ADMIN.ADMIN_BILLING.FUNDING_SOURCE.UPDATE',
    admin_billing_fundingSource_delete: 'ADMIN.ADMIN_BILLING.FUNDING_SOURCE.DELETE',
    //  PAYER
    admin_billing_payer_view: 'ADMIN.ADMIN_BILLING.PAYERS_LIST.VIEW',
    admin_billing_payer_create: 'ADMIN.ADMIN_BILLING.PAYERS_LIST.CREATE',
    admin_billing_payer_update: 'ADMIN.ADMIN_BILLING.PAYERS_LIST.UPDATE',
    admin_billing_payer_delete: 'ADMIN.ADMIN_BILLING.PAYERS_LIST.DELETE',
    //  BILLING__PROVIDER
    admin_billing_billingProvider_view: 'ADMIN.ADMIN_BILLING.BILLING_PROVIDER.VIEW',
    admin_billing_billingProvider_create: 'ADMIN.ADMIN_BILLING.BILLING_PROVIDER.CREATE',
    admin_billing_billingProvider_update: 'ADMIN.ADMIN_BILLING.BILLING_PROVIDER.UPDATE',
    admin_billing_billingProvider_delete: 'ADMIN.ADMIN_BILLING.BILLING_PROVIDER.DELETE',
    //  LEAVE RULES
    admin_billing_leaveRule_create: 'ADMIN.ADMIN_BILLING.LEAVE_RULE.CREATE',
    admin_billing_leaveRule_update: 'ADMIN.ADMIN_BILLING.LEAVE_RULE.UPDATE',
    admin_billing_leaveRule_delete: 'ADMIN.ADMIN_BILLING.LEAVE_RULE.DELETE',
    //  ADMIN____CARE
    // CARE 
    admin_care_create : 'ADMIN.CARE.CLIENTS.CREATE',
    admin_care_update : 'ADMIN.CARE.CLIENTS.UPDATE',
    admin_care_delete : 'ADMIN.CARE.CLIENTS.DELETE',
    admin_care_search : 'ADMIN.CARE.CLIENTS.SEARCH',
    admin_care_view : 'ADMIN.CARE.CLIENTS.VIEW',
    admin_care_export : 'ADMIN.CARE.CLIENTS.EXPORT',
    //  CLIENT__LOGS
    admin_care_incident_report_create: 'ADMIN.CARE.INCIDENT_REPORT.CREATE',
    admin_care_incident_report_view: 'ADMIN.CARE.INCIDENT_REPORT.VIEW',
    admin_care_incident_report_update: 'ADMIN.CARE.INCIDENT_REPORT.UPDATE',
    admin_care_incident_report_delete: 'ADMIN.CARE.INCIDENT_REPORT.DELETE',
    admin_care_incident_report_search: 'ADMIN.CARE.INCIDENT_REPORT.SEARCH',
    // HEALTH____PROFILE
    admin_care_healthProfile_view: 'ADMIN.CARE.HEALTH_PROFILE.VIEW',
    // HEALTH___DATA
    admin_care_healthData_view: 'ADMIN.CARE.HEALTH_PROFILE.HEALTH_DATA.VIEW',
    // ALLERGY__PROFILE
    admin_care_allergy_view: 'ADMIN.CARE.HEALTH_PROFILE.ALLERGY_PROFILE.VIEW',
    admin_care_allergy_update: 'ADMIN.CARE.HEALTH_PROFILE.ALLERGY_PROFILE.UPDATE',
    admin_care_allergy_create: 'ADMIN.CARE.HEALTH_PROFILE.ALLERGY_PROFILE.CREATE',
    admin_care_allergy_delete: 'ADMIN.CARE.HEALTH_PROFILE.ALLERGY_PROFILE.DELETE',
    // DIAGNOSIS
    admin_care_diagnosis_view: 'ADMIN.CARE.HEALTH_PROFILE.DIAGNOSIS.VIEW',
    admin_care_diagnosis_update: 'ADMIN.CARE.HEALTH_PROFILE.DIAGNOSIS.UPDATE',
    admin_care_diagnosis_create: 'ADMIN.CARE.HEALTH_PROFILE.DIAGNOSIS.CREATE',
    admin_care_diagnosis_delete: 'ADMIN.CARE.HEALTH_PROFILE.DIAGNOSIS.DELETE',

    //   ADMIN___INSURANCE
    admin_care_insurance_view: 'ADMIN.CARE.INSURANCE.VIEW',
    admin_care_insurance_update: 'ADMIN.CARE.INSURANCE.UPDATE',
    //   ADMIN___ENROLLMENT
    admin_care_enrollment_view: 'ADMIN.CARE.ENROLLMENT_BY_INDIVIDUAL.VIEW',
    // ENROLLMENT__BY__INDIVIDUAL
    admin_care_enrollment_byIndividual_update: 'ADMIN.CARE.ENROLLMENT_BY_INDIVIDUAL.UPDATE',
    admin_care_enrollment_byIndividual_create: 'ADMIN.CARE.ENROLLMENT_BY_INDIVIDUAL.CREATE',
    admin_care_enrollment_byIndividual_delete: 'ADMIN.CARE.ENROLLMENT_BY_INDIVIDUAL.DELETE',
    // ENROLLMENT__BY__PROGRAM
    admin_care_enrollment_byProgram_update: 'ADMIN.CARE.ENROLLMENT.BY_PROGRAM.UPDATE',
    admin_care_enrollment_byProgram_create: 'ADMIN.CARE.ENROLLMENT.BY_PROGRAM.CREATE',
    admin_care_enrollment_byProgram_delete: 'ADMIN.CARE.ENROLLMENT.BY_PROGRAM.DELETE',
    // ADMIN___CARE___CONTACT
    admin_care_contact_view: 'ADMIN.CARE.CONTACT.VIEW',
    admin_care_contact_update: 'ADMIN.CARE.CONTACT.UPDATE',
    admin_care_contact_create: 'ADMIN.CARE.CONTACT.CREATE',
    admin_care_contact_delete: 'ADMIN.CARE.CONTACT.DELETE',
    //   ADMIN______GENERAL
    //   ENROLLEMENT__BY___PROGRAM
    admin_general_enrollement_by_program_view: 'ADMIN.ADMIN_GENERAL.ENROLLMENT_BY_PROGRAM.VIEW',
    admin_general_enrollement_by_program_update: 'ADMIN.ADMIN_GENERAL.ENROLLMENT_BY_PROGRAM.UPDATE',
    admin_general_enrollement_by_program_create: 'ADMIN.ADMIN_GENERAL.ENROLLMENT_BY_PROGRAM.CREATE',
    admin_general_enrollement_by_program_delete: 'ADMIN.ADMIN_GENERAL.ENROLLMENT_BY_PROGRAM.DELETE',
    //  PROGRAMS
    admin_billing_program_view: 'ADMIN.ADMIN_GENERAL.PROGRAM.VIEW',
    admin_billing_program_create: 'ADMIN.ADMIN_GENERAL.PROGRAM.CREATE',
    admin_billing_program_update: 'ADMIN.ADMIN_GENERAL.PROGRAM.UPDATE',
    admin_billing_program_delete: 'ADMIN.ADMIN_GENERAL.PROGRAM.DELETE',
    //  SITE
    admin_billing_site_view: 'ADMIN.ADMIN_GENERAL.SITE.VIEW',
    admin_billing_site_create: 'ADMIN.ADMIN_GENERAL.SITE.CREATE',
    admin_billing_site_update: 'ADMIN.ADMIN_GENERAL.SITE.UPDATE',
    admin_billing_site_delete: 'ADMIN.ADMIN_GENERAL.SITE.DELETE',
    //  SCORING___METHOD
    admin_billing_scoring_method_view: 'ADMIN.ADMIN_GENERAL.SCORING_METHOD.VIEW',
    admin_billing_scoring_method_create: 'ADMIN.ADMIN_GENERAL.SCORING_METHOD.CREATE',
    admin_billing_scoring_method_update: 'ADMIN.ADMIN_GENERAL.SCORING_METHOD.UPDATE',
    admin_billing_scoring_method_delete: 'ADMIN.ADMIN_GENERAL.SCORING_METHOD.DELETE',
    /// BEHAVIOR___TARGET
    admin_billing_behavior_target_view : 'ADMIN.ADMIN_GENERAL.TARGET_BEHAVIOR.VIEW',
    admin_billing_behavior_target_update : 'ADMIN.ADMIN_GENERAL.TARGET_BEHAVIOR.UPDATE',
    admin_billing_behavior_target_create : 'ADMIN.ADMIN_GENERAL.TARGET_BEHAVIOR.CREATE',
    admin_billing_behavior_target_search : 'ADMIN.ADMIN_GENERAL.TARGET_BEHAVIOR.SEARCH',
    /// BEHAVIOR___REPLACEMENT
    admin_billing_behavior_replacement_view : 'BEHAVIOR.REPLACEMENT_BEHAVIOR.VIEW',
    admin_billing_behavior_replacement_update : 'BEHAVIOR.REPLACEMENT_BEHAVIOR.UPDATE',
    admin_billing_behavior_replacement_create : 'BEHAVIOR.REPLACEMENT_BEHAVIOR.CREATE',
    admin_billing_behavior_replacement_search : 'BEHAVIOR.REPLACEMENT_BEHAVIOR.SEARCH',
    //  SHARED__CONTACT
    admin_billing_sharedContact_view: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.VIEW',
    admin_billing_sharedContact_create: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.CREATE',
    admin_billing_sharedContact_update: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.UPDATE',
    admin_billing_sharedContact_delete: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.DELETE',
    admin_billing_sharedContactType_create : 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.TYPE.CREATE',
    admin_billing_sharedContactType_update: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.TYPE.UPDATE',
    admin_billingsharedContactType_delete: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.TYPE.DELETE',
    admin_billing_sharedContactType_view : 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.TYPE.VIEW',
    admin_billing_sharedContactInfo_view: 'ADMIN.ADMIN_GENERAL.SHARED_CONTACT.SHARED_CONTACT_LIST.VIEW',
    ///// MAIN_____BILLING
    // ___PROFESSIONAL__CLAIM
    billing_professionalClaim_create: "BILLING.PROFESSIONAL_CLAIM.PROFESSIONAL_CLAIM.CREATE",
    billing_professionalClaim_update: "BILLING.PROFESSIONAL_CLAIM.PROFESSIONAL_CLAIM.UPDATE",
    billing_professionalClaim_delete: "BILLING.PROFESSIONAL_CLAIM.PROFESSIONAL_CLAIM.DELETE",
    /////////  ____SERVICE__AUTHORIZATION
    billing_professionalClaim_serviceAuthorization_create:'BILLING.PROFESSIONAL_CLAIM.SERVICE_AUTHORIZATION.CREATE',
    billing_professionalClaim_serviceAuthorization_view:'BILLING.PROFESSIONAL_CLAIM.SERVICE_AUTHORIZATION.VIEW',
    billing_professionalClaim_serviceAuthorization_search:'BILLING.PROFESSIONAL_CLAIM.SERVICE_AUTHORIZATION.SEARCH',
    billing_professionalClaim_serviceAuthorization_update:'BILLING.PROFESSIONAL_CLAIM.SERVICE_AUTHORIZATION.UPDATE',
    billing_professionalClaim_serviceAuthorization_delete:'BILLING.PROFESSIONAL_CLAIM.SERVICE_AUTHORIZATION.DELETE',
    //  DESCRIPTION__CODE
    billing_descriptionCode_view: 'BILLING.PROFESSIONAL_CLAIM.DESCRIPTION_CODE.VIEW',
    billing_descriptionCode_create: 'BILLING.PROFESSIONAL_CLAIM.DESCRIPTION_CODE.CREATE',
    billing_descriptionCode_update: 'BILLING.PROFESSIONAL_CLAIM.DESCRIPTION_CODE.UPDATE',
    billing_descriptionCode_delete: 'BILLING.PROFESSIONAL_CLAIM.DESCRIPTION_CODE.DELETE',
    //  ATTENDANCE__TYPE
    billing_attendanceType_view: 'BILLING.PROFESSIONAL_CLAIM.ATTENDANCE_TYPE.VIEW',
    billing_attendanceType_create: 'BILLING.PROFESSIONAL_CLAIM.ATTENDANCE_TYPE.CREATE',
    billing_attendanceType_update: 'BILLING.PROFESSIONAL_CLAIM.ATTENDANCE_TYPE.UPDATE',
    billing_attendanceType_delete: 'BILLING.PROFESSIONAL_CLAIM.ATTENDANCE_TYPE.DELETE',
    ///// _____ATTENDANCE
    billing_attendance_new_view:'BILLING.ATTENDANCE.NEW.VIEW',
    billing_attendance_search_view:'BILLING.ATTENDANCE.SEARCH.VIEW',
    billing_attendance_summary_view:'BILLING.ATTENDANCE.SUMMARY.VIEW',
    // base permission
    caregiver_view_base : 'CARE_PROVIDERS.VIEW',

    // --- CAREGIVERS Permissions
    caregiver_view : 'CARE_PROVIDERS.CAREGIVERS.VIEW',
    caregiver_create : 'CARE_PROVIDERS.CAREGIVERS.CREATE',
    caregiver_update : 'CARE_PROVIDERS.CAREGIVERS.UPDATE',
    caregiver_delete :'CARE_PROVIDERS.CAREGIVERS.DELETE',

    caregiver_documents_view : 'CARE_PROVIDERS.CAREGIVERS.GENERAL.DOCUMENTS.VIEW',
    caregiver_documents_create : 'CARE_PROVIDERS.CAREGIVERS.GENERAL.DOCUMENTS.CREATE',
    caregiver_documents_update : 'CARE_PROVIDERS.CAREGIVERS.GENERAL.DOCUMENTS.UPDATE',
    caregiver_documents_delete : 'CARE_PROVIDERS.CAREGIVERS.GENERAL.DOCUMENTS.DELETE',

   caregiver_personal_info_view : 'CARE_PROVIDERS.CAREGIVERS.GENERAL.PERSONAL_INFORMATION.VIEW',
   caregiver_personal_info_update : 'CARE_PROVIDERS.CAREGIVERS.GENERAL.PERSONAL_INFORMATION.UPDATE',

    // WOUND CARE SECTION
    wound_care_view: 'WOUND_CARE.VIEW',
    wound_care_entries_view: 'WOUND_CARE.ENTRIES_VIEW',
    wound_care_create: 'WOUND_CARE.CREATE',
    wound_care_update: 'WOUND_CARE.UPDATE',
    wound_care_delete: 'WOUND_CARE.DELETE',
    wound_care_search: 'WOUND_CARE.SEARCH',
    wound_care_download: 'WOUND_CARE.DOWNLOAD',
    
    // NURSE SECTION
    nurse_view: 'CARE_PROVIDERS.NURSES.VIEW',
    nurse_create: 'CARE_PROVIDERS.NURSES.CREATE',
    nurse_update: 'CARE_PROVIDERS.NURSES.UPDATE',
    nurse_delete: 'CARE_PROVIDERS.NURSES.DELETE',

    nurse_documents_view: 'CARE_PROVIDERS.NURSES.GENERAL.DOCUMENTS.VIEW',
    nurse_documents_create: 'CARE_PROVIDERS.NURSES.GENERAL.DOCUMENTS.CREATE',
    nurse_documents_update: 'CARE_PROVIDERS.NURSES.GENERAL.DOCUMENTS.UPDATE',
    nurse_documents_delete: 'CARE_PROVIDERS.NURSES.GENERAL.DOCUMENTS.DELETE',

    nurse_personal_info_view: 'CARE_PROVIDERS.NURSES.GENERAL.PERSONAL_INFORMATION.VIEW',
    nurse_personal_info_update: 'CARE_PROVIDERS.NURSES.GENERAL.PERSONAL_INFORMATION.UPDATE',

    // Therapist one 
    therapist_view: 'CARE_PROVIDERS.THERAPISTS.VIEW',
    therapist_create: 'CARE_PROVIDERS.THERAPISTS.CREATE',
    therapist_update: 'CARE_PROVIDERS.THERAPISTS.UPDATE',
    therapist_delete: 'CARE_PROVIDERS.THERAPISTS.DELETE',

    therapist_documents_view: 'CARE_PROVIDERS.THERAPISTS.GENERAL.DOCUMENTS.VIEW',
    therapist_documents_create: 'CARE_PROVIDERS.THERAPISTS.GENERAL.DOCUMENTS.CREATE',
    therapist_documents_update: 'CARE_PROVIDERS.THERAPISTS.GENERAL.DOCUMENTS.UPDATE',
    therapist_documents_delete: 'CARE_PROVIDERS.THERAPISTS.GENERAL.DOCUMENTS.DELETE',

    therapist_personal_info_view: 'CARE_PROVIDERS.THERAPISTS.GENERAL.PERSONAL_INFORMATION.VIEW',
    therapist_personal_info_update: 'CARE_PROVIDERS.THERAPISTS.GENERAL.PERSONAL_INFORMATION.UPDATE',



    // CARE_GIVER____JOB_DETAILS
    care_giver_profile_jobDetails_view : 'CARE_PROVIDERS.GENERAL.UPDATE.JOB_DETAILS.VIEW',
    care_giver_profile_jobDetails_update : 'CARE_PROVIDERS.GENERAL.UPDATE.JOB_DETAILS.UPDATE',
    care_giver_profile_personalInformation_view : 'CARE_PROVIDERS.GENERAL.UPDATE.PERSONAL_INFORMATION.VIEW',
    care_giver_profile_personalInformation_update : 'CARE_PROVIDERS.GENERAL.UPDATE.PERSONAL_INFORMATION.UPDATE',
    care_giver_profile_documents_view : 'CARE_PROVIDERS.GENERAL.UPDATE.DOCUMENTS.VIEW',
    care_giver_profile_documents_update : 'CARE_PROVIDERS.GENERAL.UPDATE.DOCUMENTS.UPDATE',
    care_giver_profile_documents_create : 'CARE_PROVIDERS.GENERAL.UPDATE.DOCUMENTS.CREATE',
    care_giver_profile_documents_delete : 'CARE_PROVIDERS.GENERAL.UPDATE.DOCUMENTS.DELETE',
    // CARE_GIVER_____SCHEDULES
    care_giver_schedules_view : 'CARE_PROVIDERS.SCHEDULES.VIEW',
    // SCHEDULES_______SCHEDULE
    care_giver_schedules_schedules_view : 'CARE_PROVIDERS.SCHEDULES.SCHEDULE.VIEW',
    care_giver_schedules_schedules_publish : 'CARE_PROVIDERS.SCHEDULES.SCHEDULE.PUBLISH',
    care_giver_schedules_schedules_create : 'CARE_PROVIDERS.SCHEDULES.SCHEDULE.CREATE',
    care_giver_schedules_schedules_update : 'CARE_PROVIDERS.SCHEDULES.SCHEDULE.UPDATE',
    care_giver_schedules_schedules_delete : 'CARE_PROVIDERS.SCHEDULES.SCHEDULE.DELETE',
    // SCHEDULES_______TEAM_AVAILABILITY
    care_giver_schedules_teamAvailability_view : 'CARE_PROVIDERS.SCHEDULES.TEAM_AVAILABILITY.VIEW',
    // SCHEDULES________MY_AVAILABILITY
    care_giver_schedules_myAvailability_view : 'CARE_PROVIDERS.SCHEDULES.MY_AVAILABILITY.VIEW',
    care_giver_schedules_myAvailability_create : 'CARE_PROVIDERS.SCHEDULES.MY_AVAILABILITY.CREATE',
    care_giver_schedules_myAvailability_update : 'CARE_PROVIDERS.SCHEDULES.MY_AVAILABILITY.UPDATE',
    care_giver_schedules_myAvailability_delete : 'CARE_PROVIDERS.SCHEDULES.MY_AVAILABILITY.DELETE',
    /// SCHEDULES_____TIME_OFF_REQUEST
    care_giver_schedules_timeOff_view : 'CARE_PROVIDERS.SCHEDULES.TIME_OFF.VIEW',
    care_giver_schedules_timeOff_approve : 'CARE_PROVIDERS.SCHEDULES.TIME_OFF.APPROVE',
    care_giver_schedules_timeOff_reject : 'CARE_PROVIDERS.SCHEDULES.TIME_OFF.REJECT',
    /// TIME_____SHEETS
    care_giver_time_sheets_view : 'CARE_PROVIDERS.TIME_SHEETS.VIEW',
    care_giver_time_sheets_timeSheets_view : 'CARE_PROVIDERS.TIME_SHEETS.TIME_SHEET.VIEW',
    care_giver_time_sheets_companySheet_view : 'CARE_PROVIDERS.TIME_SHEETS.COMPANY_TIMESHEET.VIEW',
    care_giver_time_sheets_summaries_view : 'CARE_PROVIDERS.TIME_SHEETS.SUMMARIES.VIEW',
    /// MEDICATION (MARS)
    mars_individual_medication_view : 'MARS.INDIVIDUAL_MEDICATION.VIEW',
    /// MEDICATION (MARS)   CONTINUED___MEDICATION
    mars_individual_medication_continued_medication_view : 'MARS.INDIVIDUAL_MEDICATION.CONTINUED_MEDICATION.VIEW',
    mars_individual_medication_continued_medication_create : 'MARS.INDIVIDUAL_MEDICATION.CONTINUED_MEDICATION.CREATE',
    mars_individual_medication_continued_medication_create_entry : 'MARS.INDIVIDUAL_MEDICATION.CONTINUED_MEDICATION.CREATE_ENTRY',
    mars_individual_medication_continued_medication_delete : 'MARS.INDIVIDUAL_MEDICATION.CONTINUED_MEDICATION.DELETE',
    mars_individual_medication_continued_medication_search : 'MARS.INDIVIDUAL_MEDICATION.CONTINUED_MEDICATION.SEARCH',
    mars_individual_medication_continued_medication_generate_pdf : 'MARS.INDIVIDUAL_MEDICATION.CONTINUED_MEDICATION.GENERATE_PDF',
    /// MEDICATION (MARS)  DISCONTINUED___MEDICATION
    mars_individual_medication_discontinued_medication_view: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.VIEW",
    mars_individual_medication_discontinued_medication_search: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.SEARCH",
    mars_individual_medication_discontinued_medication_generate_pdf: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.GENERATE_PDF",
    /// MEDICATION (MARS)  MISSED___MEDICATION
    mars_individual_medication_missed_medication_view: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.VIEW",
    mars_individual_medication_missed_medication_filter: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.FILTER",
    mars_individual_medication_missed_medication_search: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.SEARCH",
    mars_individual_medication_missed_medication_delete: "MARS.INDIVIDUAL_MEDICATION.DISCONTINUED_MEDICATION.DELETE",
    /// CAREGIVER_____NOTES
    care_giver_notes_view : 'NOTES.VIEW',
    care_giver_notes_note_view: 'NOTES.CAREGIVER_NOTE.VIEW',
    care_giver_notes_note_search: 'NOTES.CAREGIVER_NOTE.SEARCH',
    care_giver_notes_note_create: 'NOTES.CAREGIVER_NOTE.CREATE',
    care_giver_notes_note_update: 'NOTES.CAREGIVER_NOTE.UPDATE',
    care_giver_notes_note_create_entry: 'NOTES.CAREGIVER_NOTE.CREATE_ENTRY',
    care_giver_notes_note_delete: 'NOTES.CAREGIVER_NOTE.DELETE',
    care_giver_notes_note_download: 'NOTES.CAREGIVER_NOTE.DOWNLOAD',
    /// NURSES___NOTES
    notes_nurses_note_view: 'NOTES.NURSES_NOTE.VIEW',
    notes_nurses_note_search: 'NOTES.NURSES_NOTE.SEARCH',
    notes_nurses_note_create: 'NOTES.NURSES_NOTE.CREATE',
    notes_nurses_note_update: 'NOTES.NURSES_NOTE.UPDATE',
    notes_nurses_note_delete: 'NOTES.NURSES_NOTE.DELETE',
    /// NURSES___NOTES___ENTRY
    notes_nurses_note_entry_view: 'NOTES.NURSES_NOTE.NOTE_ENTRY.VIEW',
    notes_nurses_note_entry_search: 'NOTES.NURSES_NOTE.NOTE_ENTRY.SEARCH',
    notes_nurses_note_entry_create: 'NOTES.NURSES_NOTE.NOTE_ENTRY.CREATE',
    notes_nurses_note_entry_update: 'NOTES.NURSES_NOTE.NOTE_ENTRY.UPDATE',
    notes_nurses_note_entry_download: 'NOTES.NURSES_NOTE.NOTE_ENTRY.DOWNLOAD',
    notes_nurses_note_entry_delete: 'NOTES.NURSES_NOTE.NOTE_ENTRY.DELETE',
    /// PHYSICAL___THERAPIST___NOTES
    notes_physical_therapist_note_view: 'NOTES.PHYSICAL_THERAPIST_NOTE.VIEW',
    notes_physical_therapist_note_search: 'NOTES.PHYSICAL_THERAPIST_NOTE.SEARCH',
    notes_physical_therapist_note_create: 'NOTES.PHYSICAL_THERAPIST_NOTE.CREATE',
    notes_physical_therapist_note_update: 'NOTES.PHYSICAL_THERAPIST_NOTE.UPDATE',
    notes_physical_therapist_note_download: 'NOTES.PHYSICAL_THERAPIST_NOTE.DOWNLOAD',
    notes_physical_therapist_note_delete: 'NOTES.PHYSICAL_THERAPIST_NOTE.DELETE',
    /// PHYSICAL___THERAPIST___NOTES___ENTRY
    notes_physical_therapist_note_entry_view: 'NOTES.PHYSICAL_THERAPIST_NOTE.NOTE_ENTRY.VIEW',
    notes_physical_therapist_note_entry_search: 'NOTES.PHYSICAL_THERAPIST_NOTE.NOTE_ENTRY.SEARCH',
    notes_physical_therapist_note_entry_create: 'NOTES.PHYSICAL_THERAPIST_NOTE.NOTE_ENTRY.CREATE',
    notes_physical_therapist_note_entry_update: 'NOTES.PHYSICAL_THERAPIST_NOTE.NOTE_ENTRY.UPDATE',
    notes_physical_therapist_note_entry_download: 'NOTES.PHYSICAL_THERAPIST_NOTE.NOTE_ENTRY.DOWNLOAD',
    notes_physical_therapist_note_entry_delete: 'NOTES.PHYSICAL_THERAPIST_NOTE.NOTE_ENTRY.DELETE',
    /// BEHAVIOR__NOTES
    notes_behavior_note_view: 'NOTES.BEHAVIOR_NOTE.VIEW',
    notes_behavior_note_search: 'NOTES.BEHAVIOR_NOTE.SEARCH',
    notes_behavior_note_create: 'NOTES.BEHAVIOR_NOTE.CREATE',
    notes_behavior_note_update: 'NOTES.BEHAVIOR_NOTE.UPDATE',
    notes_behavior_note_download: 'NOTES.BEHAVIOR_NOTE.DOWNLOAD',
    notes_behavior_note_delete: 'NOTES.BEHAVIOR_NOTE.DELETE',
    /// BEHAVIOR__NOTES_ENTRY
    notes_behavior_note_entry_view: 'NOTES.BEHAVIOR_NOTE.NOTE_ENTRY.VIEW',
    notes_behavior_note_entry_create: 'NOTES.BEHAVIOR_NOTE.NOTE_ENTRY.CREATE',
    notes_behavior_note_entry_update: 'NOTES.BEHAVIOR_NOTE.NOTE_ENTRY.UPDATE',
    notes_behavior_note_entry_delete: 'NOTES.BEHAVIOR_NOTE.NOTE_ENTRY.DELETE',
    /// OCCUPATIONAL___THERAPY___NOTES
    notes_occupational_therapy_note_view: 'NOTES.OCCUPATIONAL_THERAPY_NOTE.VIEW',
    notes_occupational_therapy_note_search: 'NOTES.OCCUPATIONAL_THERAPY_NOTE.SEARCH',
    notes_occupational_therapy_note_create: 'NOTES.OCCUPATIONAL_THERAPY_NOTE.CREATE',
    notes_occupational_therapy_note_update: 'NOTES.OCCUPATIONAL_THERAPY_NOTE.UPDATE',
    notes_occupational_therapy_note_download: 'NOTES.OCCUPATIONAL_THERAPY_NOTE.DOWNLOAD',
    notes_occupational_therapy_note_delete: 'NOTES.OCCUPATIONAL_THERAPY_NOTE.DELETE',
    /// SPEECH___THERAPY___NOTES
    notes_speech_therapy_note_view: 'NOTES.SPEECH_THERAPY_NOTE.VIEW',
    notes_speech_therapy_note_search: 'NOTES.SPEECH_THERAPY_NOTE.SEARCH',
    notes_speech_therapy_note_create: 'NOTES.SPEECH_THERAPY_NOTE.CREATE',
    notes_speech_therapy_note_update: 'NOTES.SPEECH_THERAPY_NOTE.UPDATE',
    notes_speech_therapy_note_download: 'NOTES.SPEECHL_THERAPY_NOTE.DOWNLOAD',
    notes_speech_therapy_note_delete: 'NOTES.SPEECH_THERAPY_NOTE.DELETE',
    /// CAREGIVER___NOTES___SCORING___METHOD
    care_giver_notes_scoring_method_create: 'NOTES.SCORING_METHOD.CREATE',
    /// BEHAVIOR
    behavior_view : 'BEHAVIOR.VIEW',
    behavior_client_behavior_view : 'BEHAVIOR.CLIENT_BEHAVIOR.VIEW',
    behavior_client_behavior_create : 'BEHAVIOR.CLIENT_BEHAVIOR.CREATE',
    behavior_client_behavior_update : 'BEHAVIOR.CLIENT_BEHAVIOR.UPDATE',
    behavior_client_behavior_create_entry : 'BEHAVIOR.CLIENT_BEHAVIOR.CREATE_ENTRY',
    behavior_client_behavior_search : 'BEHAVIOR.CLIENT_BEHAVIOR.SEARCH',
    behavior_client_behavior_delete : 'BEHAVIOR.CLIENT_BEHAVIOR.DELETE',
    /// BEHAVIOR___EXPORT
    behavior_export_view : 'BEHAVIOR.EXPORT_BEHAVIOR.VIEW',
    behavior_export_export : 'BEHAVIOR.EXPORT_BEHAVIOR.EXPORT',

}



